import { createContext } from 'react'

export type Dict = Record<string, string>

export interface I18nValue {
  /** Current UI locale code ('en', 'ru', 'zh-hans', …) */
  locale: string
  /** BCP 47 tag of the current locale — for Date/Number formatting */
  bcp47: string
  /** Loaded dictionary; null means English (the built-in fallback) */
  dict: Dict | null
  setLocale: (code: string) => void
}

export const I18nContext = createContext<I18nValue>({
  locale: 'en',
  bcp47: 'en',
  dict: null,
  setLocale: () => {},
})
